// scoresheetUtils.js

// ============================================================
// Fonctions utilitaires pour les feuilles de pointage
// ============================================================
import { HANDICAPTYPE } from "../shared/constants/constants";

// Initialise les stats d'équipes avec n rondes
function initTeamStats(n) {
  return [
    { points: 0, totalHdcpPoints: 0, totalPoints: 0, totalRoundPts: 0, rounds: createEmptyRoundsStatsTeams(n) },
    { points: 0, totalHdcpPoints: 0, totalPoints: 0, totalRoundPts: 0, rounds: createEmptyRoundsStatsTeams(n) },
  ];
}

// Crée une structure vide pour les stats des joueurs
function createEmptyRoundsStatsPlayers(n) {
  const rounds = [];
  for (let i = 0; i < n; i++) {
    rounds.push({
      wins: 0, losses: 0, cumulWins: 0, cumulLosses: 0,
      pp: 0, pa: 0, cumulPp: 0, cumulPa: 0,
    });
  }
  return rounds;
}

// Crée une structure vide pour les stats des équipes
function createEmptyRoundsStatsTeams(n) {
  const rounds = [];
  for (let i = 0; i < n; i++) {
    rounds.push({ pp: 0, hdcpPoints: 0, ppTot: 0, cumulPp: 0, cumulPpTot: 0, rndPt: 0 });
  }
  return rounds;
}

// Formatte un différentiel numérique (+ ou -)
export function formatDiffNumber(num) {
  return num > 0 ? `+${num}` : num.toString();
}

// ============================================================
// Gestion des ratings des joueurs
// ============================================================

// Retourne le rating d'un joueur trouvé dans matchPlayersList
export function getPlayerRating(playerId, matchPlayersList) {
  const player = matchPlayersList.find(mp => mp._id === playerId);
  return player ? player.rating : '--';
}

// Met à jour les ratings des joueurs dans un match (à partir de matchPlayersList)
export const updatePlayerRatings = (match, matchPlayersList, debugForceRating = '0') => {

  console.log("TAG updatePlayerRatings")
  // console.log(match, matchPlayersList)

  if (!matchPlayersList || !Array.isArray(matchPlayersList)) {
    console.log("updatePlayerRatings safety net")
    return match;   // safety net
  }

  match.rounds.forEach(round => {
    round.matchups.forEach(mu => {
      // p1
      if (mu.p1player?.length) {
        mu.p1player[0].rating = getPlayerRating(mu.p1player[0].playerId, matchPlayersList);
      }
      // p2
      if (mu.p2player?.length) {
        mu.p2player[0].rating = getPlayerRating(mu.p2player[0].playerId, matchPlayersList);
      }
      // debug
      if (debugForceRating !== '0' && m.p1player[0].playerId === "58544ee715f60d187fbf9ef2") {
        m.p1player[0].rating = debugForceRating;
      }
    });
  });

  return match;
};


// ============================================================
// Calcul complet d'une feuille de pointage (updateScores)
// ============================================================
export function calculateScores(match, matchDetails, season) {
  console.log("TAG calculateScores")
  // console.log(match, matchDetails);

  // Copie du match
  const updatedMatch = { ...match };
  const { matchPlayersList } = matchDetails;
  const playerStats = matchPlayersList.map(p => ({
    playerId: p._id,
    rounds: createEmptyRoundsStatsPlayers(match.rounds.length)
  }));
  const teamStats = initTeamStats(match.rounds.length);

  let bMatchCompleted = true;
  let hasNDrating = false;

  updatedMatch.rounds.forEach((r, rIdx) => {
    let team1roundPoints = 0;
    let team2roundPoints = 0;
    let bRoundCompleted = true;
    let team1RatingValue = 0;
    let team2RatingValue = 0;
    let roundHasNDrating = false;

    r.matchups.forEach((m, mIdx) => {
      m.p1score = (m.p1scoreStatus === 'unset') ? 0 : m.p1score;
      m.p2score = (m.p2scoreStatus === 'unset') ? 0 : m.p2score;
      const p1score = parseInt(m.p1score, 10);
      const p2score = parseInt(m.p2score, 10);
      team1roundPoints += p1score;
      team2roundPoints += p2score;

      const p1 = playerStats.find(p => p.playerId === m.p1player[0].playerId);
      const p2 = playerStats.find(p => p.playerId === m.p2player[0].playerId);
      if (p1) {
        p1.rounds[rIdx].pp += p1score;
        p1.rounds[rIdx].pa += p2score;
        if (p1score > p2score) p1.rounds[rIdx].wins++;
        else if (p1score < p2score) p1.rounds[rIdx].losses++;
      }
      if (p2) {
        p2.rounds[rIdx].pp += p2score;
        p2.rounds[rIdx].pa += p1score;
        if (p2score > p1score) p2.rounds[rIdx].wins++;
        else if (p2score < p1score) p2.rounds[rIdx].losses++;
      }

      m.p1score = (m.p1scoreStatus === 'set') ? m.p1score : '';
      m.p2score = (m.p2scoreStatus === 'set') ? m.p2score : '';

      // Gestion ND: si rating === "ND", on marque et on ne cumule pas
      const p1Rating = m.p1player[0].rating;
      const p2Rating = m.p2player[0].rating;

      if (p1Rating === "ND" || p2Rating === "ND") {
        roundHasNDrating = true;
        hasNDrating = true;
      }

      if (p1Rating !== "ND") {
        team1RatingValue += parseInt(p1Rating, 10) || 0;
      }
      if (p2Rating !== "ND") {
        team2RatingValue += parseInt(p2Rating, 10) || 0;
      }

      bRoundCompleted = bRoundCompleted && (m.p1scoreStatus === 'set') && (m.p2scoreStatus === 'set');
      bMatchCompleted = bMatchCompleted && bRoundCompleted;
    });

    playerStats.forEach(p => {
      const prev = p.rounds[Math.max(rIdx - 1, 0)];
      const curr = p.rounds[rIdx];
      curr.cumulWins = prev.cumulWins + curr.wins;
      curr.cumulLosses = prev.cumulLosses + curr.losses;
      curr.cumulPp = prev.cumulPp + curr.pp;
      curr.cumulPa = prev.cumulPa + curr.pa;
    });

    // this is done each round
    // save handicap per round
    
    // console.log("scoresheetUtils")
    // console.log("season handicapType/Max", season.handicapType, season.handicapMax)

    let t1Hdcp = 0;
    let t2Hdcp = 0;
    if (!roundHasNDrating) {
      const diffRatings = team1RatingValue - team2RatingValue;
      t1Hdcp = (diffRatings > 0) ? Math.min(diffRatings / 10, season.handicapMax) : 0;
      t2Hdcp = (diffRatings < 0) ? Math.min(-diffRatings / 10, season.handicapMax) : 0;
    }

    teamStats[0].rounds[rIdx].hdcpPoints = t1Hdcp;
    teamStats[1].rounds[rIdx].hdcpPoints = t2Hdcp;
    teamStats[0].rounds[rIdx].pp = team1roundPoints;
    teamStats[1].rounds[rIdx].pp = team2roundPoints;

    const prev0 = teamStats[0].rounds[Math.max(rIdx - 1, 0)];
    const prev1 = teamStats[1].rounds[Math.max(rIdx - 1, 0)];
    teamStats[0].rounds[rIdx].cumulPp = prev0.cumulPp + team1roundPoints;
    teamStats[1].rounds[rIdx].cumulPp = prev1.cumulPp + team2roundPoints;
    teamStats[0].rounds[rIdx].ppTot = team1roundPoints + t1Hdcp;
    teamStats[1].rounds[rIdx].ppTot = team2roundPoints + t2Hdcp;
    teamStats[0].rounds[rIdx].cumulPpTot = prev0.cumulPpTot + teamStats[0].rounds[rIdx].ppTot;
    teamStats[1].rounds[rIdx].cumulPpTot = prev1.cumulPpTot + teamStats[1].rounds[rIdx].ppTot;

    // Points de ronde
    if (bRoundCompleted) {
      const diff = (team1roundPoints + t1Hdcp) - (team2roundPoints + t2Hdcp);
      if (diff > 0) { teamStats[0].rounds[rIdx].rndPt = 1; }
      else if (diff < 0) { teamStats[1].rounds[rIdx].rndPt = 1; }
      else { teamStats[0].rounds[rIdx].rndPt = teamStats[1].rounds[rIdx].rndPt = 0.5; }
    }

    teamStats[0].points += team1roundPoints;
    teamStats[1].points += team2roundPoints;
    teamStats[0].totalHdcpPoints += teamStats[0].rounds[rIdx].hdcpPoints;
    teamStats[1].totalHdcpPoints += teamStats[1].rounds[rIdx].hdcpPoints;
    teamStats[0].totalPoints = teamStats[0].points + teamStats[0].totalHdcpPoints;
    teamStats[1].totalPoints = teamStats[1].points + teamStats[1].totalHdcpPoints;

    teamStats[0].totalRoundPts += teamStats[0].rounds[rIdx].rndPt;
    teamStats[1].totalRoundPts += teamStats[1].rounds[rIdx].rndPt;
  });

  // Points de match
  if (bMatchCompleted) {
    const diff = (teamStats[0].rounds.at(-1).cumulPpTot) - (teamStats[1].rounds.at(-1).cumulPpTot);
    if (diff > 0) teamStats[0].matchPt = 1;
    else if (diff < 0) teamStats[1].matchPt = 1;
    else teamStats[0].matchPt = teamStats[1].matchPt = 0.5;
  }

  return { updatedMatch, playerStats, teamStats, hasNDrating };
}
